function setToken(token) {
    sessionStorage.setItem('token', token)
}

function getToken() {
    return sessionStorage.getItem('token')
}

function setUserInfo(userInfo) {
    userInfo = JSON.stringify(userInfo)
    sessionStorage.setItem('userInfo', userInfo)
}

function getUserInfo() {
    let userInfo = sessionStorage.getItem('userInfo')
    return JSON.parse(userInfo)
}

export {
    setToken,
    getToken,
    setUserInfo,
    getUserInfo,
}
